import { BaseEvent } from '~/app/tracking/events/base-event';
import { EventAction } from '~/app/tracking/feld-m-types';

export type ErrorEventParams = {
	name: string;
	userMessage?: string;
};

export class ErrorEvent extends BaseEvent {
	constructor({ name, userMessage }: ErrorEventParams) {
		super({
			eventInfo: {
				eventAction: EventAction.Error,
				eventName: `configurator - error - ${name}`,
			},
			attributes: {
				value: userMessage || '',
			},
		});
	}
}
